import AuthLayout from "../../layout/authLayout";
import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "src/firebase/firebase";
import { useState } from "react";
import { handleToastMessage } from "src/js/handleToastMessage";

const validationSchema = Yup.object().shape({
  email: Yup.string().email().trim().required("Email is required."),
});
const initialValues = {
  email: "",
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleForgotPassword = (values: any) => {
    console.log(values);
    setIsLoading(true);
    sendPasswordResetEmail(auth, values.email)
      .then((res) => {
        setIsLoading(false);
        handleToastMessage(
          "success",
          "Please reset link sent to your respective email"
        );
        navigate("/");
      })
      .catch(() => {
        setIsLoading(false);
        handleToastMessage("error", "Something went wrong");
      });
  };

  return (
    <>
      <AuthLayout
        title="Forgot Password?"
        subTitle="No worries, we'll send you to reset instructions on email."
      >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleForgotPassword}
          validateOnBlur
        >
          {({ errors, touched, handleSubmit, handleBlur, handleChange }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="p-2">
                  <Input
                    label="Email ID"
                    containerClass="w-full"
                    placeholder="Email"
                    name="email"
                    error={errors.email}
                    touched={touched.email}
                    variant="solid"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>

                <Button
                  className="ml-0 block  w-full bg-blue mt-4 mb-3"
                  loading={isLoading}
                  type="submit"
                >
                  Reset Password
                </Button>
                <p
                  className="text-blue font-semibold text-center cursor-pointer ml-1"
                  onClick={() => navigate("/signin")}
                >
                  Back To Login
                </p>
              </form>
            );
          }}
        </Formik>
      </AuthLayout>
    </>
  );
};
export default ForgotPassword;
